module.exports = __webpack_public_path__ + "static/media/paris_1701970945294_kanha.823daf18.png";